import PropTypes from 'prop-types';
import React from 'react';
import PDF from '../../common/pdf/pdf';
const PDFViewer = ({
  label: _label = null,
  url,
  height
}) => /*#__PURE__*/React.createElement(PDF, {
  src: url,
  title: _label,
  containerMaxHeight: height,
  hideTitleIfMobile: true,
  nativeRenderer: true
});
PDFViewer.propTypes = {
  label: PropTypes.string,
  url: PropTypes.string.isRequired,
  height: PropTypes.number.isRequired
};
export default PDFViewer;